import React from 'react';
import Main from '../common/main';
import ConceptB from './concept-b';
import { useDataStorage, DataStorageContext } from './hooks';

const Concept = ({ onNext }) => {
  const { 
    total,
    isDataFilled,
    onCheckout,
    ...rest
  } = useDataStorage(onNext);
  return <Main total={total} disableCheckout={!isDataFilled} onCheckout={onCheckout}>
    <DataStorageContext.Provider value={rest}>
      <ConceptB />
    </DataStorageContext.Provider>
  </Main>
}

export default Concept;